import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, combineLatest, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IsToggledService {

  public isSidebarOpen = new BehaviorSubject<boolean>(false);
  public isLangDropDownOpen = new BehaviorSubject<boolean>(false);
  public isRedirectConfirmModalOpen = new BehaviorSubject<boolean>(false);
  public isLoginErrorModalOpen = new BehaviorSubject<boolean>(false);

  constructor() { }

  /**
   * Metodo utilizzato per bloccare la navigazione tramite screen-reader
   * nel momento in cui un elemento (di default nascosto) va in primo piano
   * @returns la navigabilita' dell'elemento
   */
  public isElementNavigable(): Observable<boolean> {
    return combineLatest([
      this.isSidebarOpen,
      this.isLangDropDownOpen,
      this.isRedirectConfirmModalOpen,
      this.isLoginErrorModalOpen
      //TODO aggiungere altri behaviourSubject per ogni elemento che triggeri il blocco
    ]).pipe(
      map(([sidebarOpen, langDropdownOpen, redirectConfirmModal, loginErrorModal /*, altri stati */]) => {
        // Se almeno uno tra gli elementi in primo piano è aperto,
        // blocca gli elementi che non dovrebbero essere navigabili (ritorna false)
        return !(sidebarOpen || langDropdownOpen || redirectConfirmModal || loginErrorModal /* || altri controlli */);
      })
    );
  }

  //* SETTER

  public setSidebarStatus(status: boolean){
    this.isSidebarOpen.next(status);
  }

  public setLangDropDownStatus(status: boolean){
    this.isLangDropDownOpen.next(status);
  }

  public setRedirectConfirmModalStatus(status: boolean){
    this.isRedirectConfirmModalOpen.next(status);
  }

  public setLoginErrorModalStatus(status: boolean){
    this.isLoginErrorModalOpen.next(status);
  }

  //* GETTER

  public getSidebarStatus(): Observable<boolean> {
    return this.isSidebarOpen.asObservable();
  }
  public getLangDropDownStatus(): Observable<boolean> {
    return this.isLangDropDownOpen.asObservable();
  }
  public getRedirectConfirmModalStatus(): Observable<boolean> {
    return this.isRedirectConfirmModalOpen.asObservable();
  }
  public getLoginErrorModalStatus(): Observable<boolean> {
    return this.isLoginErrorModalOpen.asObservable();
  }
}
